module.exports = __webpack_public_path__ + "static/media/hand-holding-magic.cd76836e.svg";